import { render, staticRenderFns } from "./ModalUsuarioExcluido.vue?vue&type=template&id=a1a113f4"
import script from "./ModalUsuarioExcluido.vue?vue&type=script&lang=js"
export * from "./ModalUsuarioExcluido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports